const TopUpAnnatelURL = (topUp, number) => {
  const url = window.location.href;
  const queryStringNumber = number ?  "subscribe.php?number=" + number : '';
  const websiteURL =  url.includes('en_US') ? "https://www.annatel.us/" + topUp + "/en/" : "https://www.annatel.co.il/"+ topUp + "/fr/";

  return websiteURL + queryStringNumber;
}
export default TopUpAnnatelURL;



// WEBPACK FOOTER //
// ./src/localeAssets/TopUpAnnatelURL.js